import { erpAxios } from '..';

const statusOdustao = async (data) => {
  const res = await erpAxios.post(`/statusZahtjeva/odustao`, data);
  return res;
};

export default statusOdustao;
